import React from 'react'
// layers
import ActivitiesListAPI from 'containers/Activities/layers/API/ActivitiesList'
import ActivitiesListBL from 'containers/Activities/layers/BL/ActivitiesList'
// components
import SubActivitiesList from 'components/Modals/PlanItems/components/ActivitiesList/components/SubActivitiesList'

const SubActivitiesListContainer = props => (
  <ActivitiesListAPI {...props}>
    <ActivitiesListBL {...props}>
      <SubActivitiesList />
    </ActivitiesListBL>
  </ActivitiesListAPI>
)

export default SubActivitiesListContainer
